/**
 * Sanitizes a string value by stripping characters that are not allowed
 * in form fields before storing in the database.
 *
 * Ported from the legacy DACIns Register.aspx.cs StripCharactersFromControl method.
 */
export function stripDisallowedCharacters(value: string): string {
  if (!value) {
    return value;
  }

  return value
    .replace(/&/g, 'and')
    .replace(/'/g, '')
    .replace(/\$/g, '')
    .replace(/\.\./g, '.')
    .replace(/_____-____/g, '')
    .replace(/-____/g, '');
}

/**
 * Sanitizes all string values in a flat object by applying stripDisallowedCharacters
 * to each one. Returns a new object with the sanitized values.
 *
 * @param excludeKeys - Keys to skip (e.g. passwords, dropdowns that should not be altered).
 */
export function stripFormValues<T extends Record<string, any>>(
  formValues: T,
  excludeKeys: string[] = [],
): T {
  const result = { ...formValues };
  for (const key of Object.keys(result)) {
    if (typeof result[key] === 'string' && !excludeKeys.includes(key)) {
      (result as any)[key] = stripDisallowedCharacters(result[key]);
    }
  }
  return result;
}
